import {
  Beneficio,
  InfosClienteResumo,
  MatriculaResumo,
  MetodosFgts,
  Referencia,
  TYPES
} from './types'
import { SagaIterator } from 'redux-saga'
import {
  AllEffect,
  CallEffect,
  all,
  call,
  delay,
  fork,
  put,
  select,
  takeEvery
} from 'redux-saga/effects'
import * as loadingActions from 'store/modules/loading/actions'
import { SIMULACAO } from './types'
import { ApplicationState } from 'store'
import { handlerError } from 'util/handlerError'
import { toast } from 'react-toastify'
import { handlerErrorSimulacao } from 'util/handlerErroSimulacao'
import { handlerErrorSimulacaoFgts } from 'util/handlerErrorSimulacaoFGTS'
import { maskCPF, maskMoney, removeMaskCPF, removeMaskMoney } from 'util/masks'
import {
  Indicacao,
  ListaValoresLiberado,
  ProdutosSimulacao,
  ReqFgts,
  ReqSimuladorSimulacao,
  ResponseWithMessages,
  SimulacaoCrefaz
} from 'models/types'
import { AxiosResponse } from 'axios'
import { handlerErrorFgts } from 'util/handlerErrorFgts'
import * as simulacaoActions from 'store/modules/simulacao/actions'
import * as meusDadosActions from 'store/modules/meusDados/actions'
import * as simulacaoController from 'controller/simulacaoController'
import { FinalizacaoEmprestimoCrefaz } from 'controller/simulacaoController'
import * as cadastroInicialController from 'controller/cadastroInicialController'
import moment from 'moment'
import { stepCadastroComplementarRedirect } from 'util/stepCadastroComplementarRedirect'
import history from 'util/history'
import { MEUS_DADOS } from '../meusDados/types'
import { Matricula } from 'models/meusDados/types'

interface GenericProps {
  type: string
}

function* getClienteMatriculaCpf(): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))
    const response = yield call(simulacaoController.getClienteMatriculaCpf)
    yield put(simulacaoActions.setNomeCompleto(response?.data?.content.nome))
    yield put(simulacaoActions.setCpf(response?.data?.content.cpf))
    yield put(
      simulacaoActions.setBeneficios(response?.data?.content.matriculas)
    )
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* validaStatusIN100(): SagaIterator {
  const { beneficios, cpf }: SIMULACAO = yield select(
    (state: ApplicationState) => state.simulacao
  )
  const { meusDados }: MEUS_DADOS = yield select(
    (state: ApplicationState) => state.meusDados
  )

  const urlAtual = window.location.href
  try {
    const cpfFormatted = removeMaskCPF(cpf)
    let filteredBeneficios: Matricula[] | Beneficio[] = []

    if (urlAtual.endsWith('/meus-dados')) {
      filteredBeneficios = meusDados.matriculas?.filter(
        (matricula) => matricula.tipoPerfil === 1
      )
    } else {
      filteredBeneficios = beneficios?.filter(
        (beneficio) => beneficio.clientePerfil.tipoPerfil === 1
      )
    }

    const matriculasQuePrecisamDeValidacao: string[] = []

    /* eslint-disable @typescript-eslint/no-explicit-any */
    const getValidacoesMatriculasInss = function* (): Generator<
      AllEffect<Generator<CallEffect<AxiosResponse<any, any>>, any, unknown>>,
      void,
      AxiosResponse<ReqSimuladorSimulacao<any>, any>[]
    > {
      // yield all(
      //   filteredBeneficios.map(function* (beneficio: any) {
      //     try {
      //       const response: AxiosResponse<
      //         ReqSimuladorSimulacao<any>,
      //         any
      //       > = yield call(
      //         simulacaoController.validaStatusIN100,
      //         cpfFormatted,
      //         urlAtual.endsWith('/meus-dados')
      //           ? beneficio.numeroMatricula
      //           : beneficio.numero
      //       )
      //       if (response?.data?.modalIn100 === true) {
      //         matriculasQuePrecisamDeValidacao.push(beneficio.numero)
      //       }
      //       return response
      //     } catch (error) {
      //       matriculasQuePrecisamDeValidacao.push(
      //         urlAtual.endsWith('/meus-dados')
      //           ? beneficio.numeroMatricula
      //           : beneficio.numero
      //       )
      //       handlerErrorSimulacao(
      //         error,
      //         'Houve um erro ao tentar realizar uma validação'
      //       )
      //       return null
      //     }
      //   })
      // )
    }
    /* eslint-enable @typescript-eslint/no-explicit-any */

    if (filteredBeneficios.length) {
      yield call(getValidacoesMatriculasInss)
    }

    yield put(
      simulacaoActions.setMatriculasValidacao(matriculasQuePrecisamDeValidacao)
    )

    if (!matriculasQuePrecisamDeValidacao.length) {
      yield put(simulacaoActions.getPropostasSaga())
    } else {
      if (urlAtual.endsWith('/meus-dados')) {
        yield put(meusDadosActions.toggleModalIN100(true))
      }
      yield put(simulacaoActions.toggleModalIN100(true))
    }
  } catch (error) {
    handlerError(error, 'Houve um erro ao tentar realizar uma validação')
  }
}

function* getPropostas(): SagaIterator {
  const { beneficios, cpf }: SIMULACAO = yield select(
    (state: ApplicationState) => state.simulacao
  )
  try {
    yield put(simulacaoActions.setLoadingSimulacao(true))
    yield put(simulacaoActions.setProdutosDisponiveis([]))
    yield put(simulacaoActions.setProdutosSelecionados([]))
    yield put(simulacaoActions.setIsUploadedArquivosCrefaz(false))
    const cpfFormatted = removeMaskCPF(cpf)
    let response: ProdutosSimulacao[] = []
    const getSimulacoes = function* (): Generator<
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      AllEffect<Generator<CallEffect<AxiosResponse<any, any>>, any, unknown>>,
      void,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      AxiosResponse<ReqSimuladorSimulacao<any>, any>[]
    > {
      const filteredBeneficios = beneficios?.filter(
        (beneficio) => beneficio.clientePerfil.tipoPerfil !== 2
      )

      const getPropostaCrefaz = function* () {
        try {
          const response: AxiosResponse<
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ReqSimuladorSimulacao<any>,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            any
          > = yield call(simulacaoController.getPropostasCrefaz, cpfFormatted)
          return response
        } catch (error) {
          handlerErrorSimulacao(
            error,
            'Houve um erro ao realizar a simulação, tente novamente mais tarde.'
          )
          return null
        }
      }

      const responses = yield all([
        ...filteredBeneficios.map(function* (beneficio) {
          try {
            const response: AxiosResponse<
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              ReqSimuladorSimulacao<any>,
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              any
            > = yield call(
              simulacaoController.getPropostasCrm,
              cpfFormatted,
              beneficio.numero
            )
            return response
          } catch (error) {
            handlerErrorSimulacao(
              error,
              'Houve um erro ao realizar a simulação, tente novamente mais tarde.'
            )
            return null
          }
        }),
        getPropostaCrefaz()
      ])

      responses?.map((res) => {
        if (res?.data?.content || res?.data?.content?.length > 0) {
          if (Array.isArray(res?.data?.content)) {
            response = response.concat(res?.data?.content)
          } else {
            if (!res?.data?.content?.mensagemModal) {
              response.push(res?.data?.content)
            }
          }
        }

        if (res?.data?.messages && res?.data?.messages?.length > 0) {
          handlerErrorSimulacao(res?.data)
        }
      })
    }

    yield call(getSimulacoes)

    let produtosDisponiveis: ProdutosSimulacao[] = []

    for (const produto of response) {
      let simulacoesCrefaz: SimulacaoCrefaz[] = []
      if (produto.servico === 13) {
        simulacoesCrefaz =
          produto.simulacoesCrefaz?.map((simulacao) => {
            const maiorValorLiberado =
              simulacao.empresasConveniadas?.[0].listaValoresLiberados?.reduce(
                (max, item) => {
                  return item.valor > max.valor ? item : max
                },
                simulacao.empresasConveniadas?.[0].listaValoresLiberados?.[0]
              )

            const maiorPrazo = maiorValorLiberado.listaParcelas?.reduce(
              (max, item) => {
                return item.prazo > max.prazo ? item : max
              },
              maiorValorLiberado.listaParcelas[0]
            )
            return {
              ...simulacao,
              selecionados: {
                convenioDados: [
                  ...(simulacao.empresasConveniadas?.[0].convenioDados || [])
                ],
                convenioId: simulacao.empresasConveniadas?.[0].convenioId ?? 0,
                prazo: maiorPrazo?.prazo ?? null,
                valorParcela: maiorPrazo?.valor ?? null,
                valorSolicitado: maiorValorLiberado?.valor ?? 0
              }
            }
          }) ?? []
      }

      produtosDisponiveis.push({
        banco: produto.banco,
        codigoFator: produto.codigoFator,
        codigoFormaEnvioTermo: produto.codigoFormaEnvioTermo,
        codigoProduto: produto.codigoProduto,
        codigoSimulacao: produto.codigoSimulacao,
        cpf: produto.cpf,
        id: produto.id,
        listProdutos: produto.listProdutos,
        listParcelas: produto.listParcelas,
        mensagemOperadora: produto.mensagemOperadora,
        matricula: produto.matricula,
        perfil: produto.perfil,
        porcentagemFator: produto.porcentagemFator,
        qtdeParcelas: produto.qtdeParcelas,
        servico: produto.servico,
        valorDesejado: produto.valorDesejado,
        valorLimite: produto.valorLimite,
        valorParcela: produto.valorParcela,
        valorSaqueMaximo: produto.valorSaqueMaximo,
        valorSaqueMinimo: produto.valorSaqueMinimo,
        valorTotalFinanciado: produto.valorTotalFinanciado,
        flagSaqueAutorizado:
          produto.servico === 5 ||
          produto.servico === 6 ||
          produto.servico === 8 ||
          produto.servico === 12, //Desabilitando campo do cartão benefício até que seja integrado: produto.servico === 5 || produto.servico === 6 || produto.servico === 7 || produto.servico === 8
        flagSaqueParcelado:
          produto.servico === 5 ||
          produto.servico === 7 ||
          produto.servico === 6 ||
          produto.servico === 8,
        valorSaque: maskMoney(Number(produto.valorSaque).toFixed(2)),
        flagAberturaConta: false,
        bancoSimulacaoEnum: produto.bancoSimulacaoEnum,
        margemDisponivel: produto.margemDisponivel,
        margemDisponivelCartao: produto.margemDisponivelCartao,
        margemDisponivelCartaoBeneficio:
          produto.margemDisponivelCartaoBeneficio,
        produtosSINDNAP: produto.produtosSINDNAP,
        tipoProduto: produto.tipoProduto,
        numeroContaInterna: produto.numeroContaInterna,
        simulacoesCrefaz: simulacoesCrefaz
      })
    }

    const produtosSindnapi = response.filter(
      (produto: ProdutosSimulacao) => produto.servico === 12
    )
    let produtoMaiorValor: ProdutosSimulacao | null = null
    let maiorValor = 0
    produtosSindnapi.map((produto: ProdutosSimulacao) => {
      if (
        (produto.produtosSINDNAP?.planos?.[0]?.valorPremioAux ?? 0) > maiorValor
      ) {
        maiorValor = produto.produtosSINDNAP?.planos[0].valorPremioAux ?? 0
        produtoMaiorValor = produto
      }
    })
    if (produtoMaiorValor) {
      produtosDisponiveis = produtosDisponiveis?.filter(
        (produto) => produto.servico !== 12
      )
      produtosDisponiveis.push(produtoMaiorValor)
    }
    yield put(simulacaoActions.setProdutosDisponiveis([...produtosDisponiveis]))
    yield put(
      simulacaoActions.setProdutosSelecionados([
        ...produtosDisponiveis.filter((produto) => {
          return !(
            (produto.servico === 5 || produto.servico === 8) &&
            produto.valorTotalFinanciado === 0
          )
        })
      ])
    )
    yield put(simulacaoActions.setJaSimulado())
    const valorTotalPorProduto = {
      cf_site_valor_disponivel_cartao_beneficio: 0,
      cf_site_valor_disponivel_cartao_consignado: 0,
      cf_site_valor_disponivel_saque_aniversario_fgts: 0,
      cf_site_valor_disponivel_saque_cartao_beneficio: 0,
      cf_site_valor_disponivel_saque_cartao_consignado: 0,
      cf_site_valor_disponivel_crefaz: 0,
      cf_site_valor_disponivel_portabilidade: 0,
      cf_site_valor_disponivel_refin: 0,
      cf_site_valor_disponivel_emprestimo_consignado: 0
    }

    produtosDisponiveis.forEach((produto) => {
      const { valorTotalFinanciado, valorSaque, valorPremioAux } = (() => {
        const valorTotalFinanciado = Number(produto.valorTotalFinanciado ?? 0)

        const valorSaque = produto.valorSaque
          ? Number(removeMaskMoney(produto.valorSaque))
          : 0

        const valorPremioAux = Number(
          produto.produtosSINDNAP?.planos?.[0]?.valorPremioAux ?? 0
        )

        return {
          valorTotalFinanciado,
          valorSaque,
          valorPremioAux
        }
      })()

      switch (produto.servico) {
        case 6:
          valorTotalPorProduto.cf_site_valor_disponivel_cartao_consignado +=
            valorSaque
          break
        case 7:
          valorTotalPorProduto.cf_site_valor_disponivel_cartao_beneficio +=
            valorSaque
          break
        case 8:
          valorTotalPorProduto.cf_site_valor_disponivel_saque_cartao_beneficio +=
            valorSaque
          break
        case 5:
          valorTotalPorProduto.cf_site_valor_disponivel_saque_cartao_consignado +=
            valorSaque
          break
        case 9:
          valorTotalPorProduto.cf_site_valor_disponivel_saque_aniversario_fgts +=
            valorSaque
          break
        case 13:
          valorTotalPorProduto.cf_site_valor_disponivel_crefaz += valorPremioAux
          break
        case 2:
          valorTotalPorProduto.cf_site_valor_disponivel_refin +=
            valorTotalFinanciado

          break
        case 1:
          valorTotalPorProduto.cf_site_valor_disponivel_emprestimo_consignado +=
            valorTotalFinanciado
          break
      }
    })
    const valorTotalProduto = Object.fromEntries(
      Object.entries(valorTotalPorProduto).map(([chave, valor]) => [
        chave,
        valor > 0 ? valor.toFixed(2) : ''
      ])
    )

    const somatorioTotalProdutos = produtosDisponiveis
      .map((produto) => {
        if (
          produto.servico === 5 ||
          produto.servico === 6 ||
          produto.servico === 7 ||
          produto.servico === 8
        ) {
          if (!produto.flagSaqueAutorizado && !produto.flagSaqueParcelado) {
            return 0
          } else {
            return Number(removeMaskMoney(produto.valorSaque))
          }
        } else if (produto.servico === 13) {
          let valor = 0
          for (const simulacao of produto.simulacoesCrefaz ?? []) {
            valor += simulacao.selecionados.valorSolicitado
          }
          return valor
        } else {
          return produto.valorTotalFinanciado
        }
      })
      .reduce((prev, curr) => prev + curr, 0)

    yield call(cadastroInicialController.atualizarContatoRDStation, null, {
      cf_site_valor_total_disponivel: String(somatorioTotalProdutos.toFixed(2)),
      tags: ['etapa_simulacao'],
      ...valorTotalProduto
    })
  } catch (error) {
    handlerErrorSimulacao(
      error,
      'Houve um erro ao realizar a simulação, tente novamente mais tarde.'
    )
  } finally {
    yield put(simulacaoActions.setLoadingSimulacao(false))
    if (
      beneficios.find((beneficio) => beneficio.clientePerfil.tipoPerfil === 2)
    ) {
      yield put(simulacaoActions.solicitarSimulacaoFgtsSaga())
    }
  }
}

function* solicitarSimulacaoFgts(): SagaIterator {
  const maxRetries = 3
  let attempt = 0
  let success = false
  try {
    yield put(simulacaoActions.setLoadingSimulacao(true))

    while (attempt < maxRetries && !success) {
      try {
        yield call(simulacaoController.solicitarSimulacaoFgts)
        success = true
      } catch (error) {
        attempt++
        if (attempt < maxRetries) {
          yield delay(10000)
        } else {
          throw error
        }
      }
    }

    if (success) {
      yield put(simulacaoActions.getParcelasFgtsSaga())
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    if (Array.isArray(error?.messages)) {
      const { messages } = error
      for (const err of messages as Indicacao[]) {
        yield put(
          simulacaoActions.setInfosModalIndicacao({
            indicacao: err.indicacao,
            isOpen: true,
            metodoFgts: MetodosFgts.SolicitarSimulacao
          })
        )
      }
    } else {
      handlerErrorSimulacaoFgts(
        error,
        'Houve um erro ao solicitar a simulação do FGTS, tente novamente mais tarde.'
      )
    }
  } finally {
    yield put(simulacaoActions.setLoadingSimulacao(false))
  }
}

function* getParcelasFgts(): SagaIterator {
  const {
    cpf,
    produtosDisponiveis: produtosDisponiveisState,
    produtosSelecionados: produtosSelecionadosState
  }: SIMULACAO = yield select((state: ApplicationState) => state.simulacao)
  try {
    yield put(simulacaoActions.setLoadingSimulacao(true))
    const cpfFormatted = removeMaskCPF(cpf)
    const response = yield call(simulacaoController.getParcelaFgts)
    const produtosDisponiveis = [...produtosDisponiveisState]
    const produtosSelecionados = [...produtosSelecionadosState]

    const iDisponivel = produtosDisponiveis.findIndex(
      (produto) => produto.servico === 9
    )
    const iSelecionado = produtosSelecionados.findIndex(
      (produto) => produto.servico === 9
    )
    if (iDisponivel !== -1) {
      produtosDisponiveis.splice(iDisponivel, 1)
    }
    if (iSelecionado !== -1) {
      produtosSelecionados.splice(iSelecionado, 1)
    }

    if (response?.data?.content && response?.data?.content.hoje) {
      const produtoFgts: ProdutosSimulacao = {
        id: 'fgts',
        perfil: 1,
        qtdeParcelas: Number(response?.data?.content?.quantidadeParcelas),
        servico: 9,
        valorTotalFinanciado: Number(response?.data?.content?.valorLiberado),
        parcelasFgtsItem: response?.data?.content?.parcelasFgtsItem,
        banco: 'BMG',
        codigoFator: '',
        codigoFormaEnvioTermo: null,
        codigoProduto: null,
        cpf: cpfFormatted,
        listProdutos: [],
        listParcelas: [],
        mensagemOperadora: null,
        matricula: '0',
        porcentagemFator: 0,
        valorDesejado: 0,
        valorLimite: 0,
        valorParcela: 0,
        valorSaqueMaximo: 0,
        valorSaqueMinimo: 0,
        flagSaqueAutorizado: false,
        flagSaqueParcelado: false,
        flagAberturaConta: false,
        bancoSimulacaoEnum: 0,
        margemDisponivel: 0,
        margemDisponivelCartao: 0,
        margemDisponivelCartaoBeneficio: 0,
        tipoProduto: 0,
        valorSaque: maskMoney(0),
        produtosSINDNAP: undefined,
        numeroContaInterna: null
      }
      produtosDisponiveis.push(produtoFgts)
      produtosSelecionados.push(produtoFgts)
    }
    yield put(simulacaoActions.setProdutosDisponiveis(produtosDisponiveis))
    yield put(simulacaoActions.setProdutosSelecionados(produtosSelecionados))
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    if (Array.isArray(error?.messages)) {
      const { messages } = error
      for (const err of messages as Indicacao[]) {
        yield put(
          simulacaoActions.setInfosModalIndicacao({
            indicacao: err.indicacao,
            isOpen: true,
            metodoFgts: MetodosFgts.SolicitarParcelas
          })
        )
      }
    } else {
      handlerErrorSimulacaoFgts(
        error,
        'Houve um erro ao obter a oferta do FGTS, tente novamente mais tarde.'
      )
    }
  } finally {
    yield put(simulacaoActions.setLoadingSimulacao(false))
  }
}

interface RecalculoPropostaProps extends GenericProps {
  servico: number
  parcelas: number
  valorTotal: number
  valorParcela: number
  tabela: number
  valor?: number
  numeroMatricula: string
  banco: number
}

function* recalculoProposta({
  servico,
  parcelas,
  valorTotal,
  valorParcela,
  tabela,
  numeroMatricula,
  banco
}: RecalculoPropostaProps): SagaIterator {
  const {
    cpf,
    produtosDisponiveis: produtosDisponiveisState,
    produtosSelecionados: produtosSelecionadosState
  }: SIMULACAO = yield select((state: ApplicationState) => state.simulacao)
  try {
    yield put(loadingActions.setLoading(true))
    const cpfFormatted = removeMaskCPF(cpf)
    const response = yield call(
      simulacaoController.recalculoProposta,
      cpfFormatted,
      servico,
      parcelas,
      valorTotal || null,
      valorParcela || null,
      tabela,
      numeroMatricula,
      banco
    )
    const produtosDisponiveis = [...produtosDisponiveisState]
    const produtosSelecionados = [...produtosSelecionadosState]
    const indexDisponiveis = produtosDisponiveis.findIndex(
      (produto) =>
        produto.servico === response?.data?.content?.servico &&
        produto.matricula === response?.data?.content?.matricula
    )
    const indexSelecionados = produtosSelecionados.findIndex(
      (produto) =>
        produto.servico === response?.data?.content?.servico &&
        produto.matricula === response?.data?.content?.matricula
    )
    if (indexDisponiveis !== -1) {
      produtosDisponiveis[indexDisponiveis] = {
        ...produtosDisponiveis[indexDisponiveis],
        ...response?.data?.content,
        valorSaque: maskMoney(response?.data?.content?.valorSaque?.toFixed(2))
      }
    }
    if (indexSelecionados !== -1) {
      produtosSelecionados[indexSelecionados] = {
        ...produtosDisponiveis[indexDisponiveis],
        ...response?.data?.content,
        valorSaque: maskMoney(response?.data?.content?.valorSaque?.toFixed(2)),
        qtdeParcelas: response?.data?.content.qtdeParcelas
      }
    }
    yield put(simulacaoActions.setProdutosDisponiveis(produtosDisponiveis))
    yield put(simulacaoActions.setProdutosSelecionados(produtosSelecionados))
    if (response?.data?.messages?.length > 0) {
      handlerError(response?.data)
    }
    toast.success('Recálculo realizado com sucesso!')
  } catch (error) {
    handlerError(error, 'Não foi possível recalcular!')
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* recalculoPropostaFgts({
  valor = 0,
  parcelas
}: RecalculoPropostaProps): SagaIterator {
  const {
    cpf,
    produtosDisponiveis: produtosDisponiveisState,
    produtosSelecionados: produtosSelecionadosState
  }: SIMULACAO = yield select((state: ApplicationState) => state.simulacao)
  try {
    yield put(loadingActions.setLoading(true))
    const cpfFormatted = removeMaskCPF(cpf)
    yield call(simulacaoController.recalculoPropostaFgts, valor, parcelas)
    const response = yield call(simulacaoController.getParcelaFgts)

    const produtosDisponiveis = [...produtosDisponiveisState]
    const produtosSelecionados = [...produtosSelecionadosState]

    if (response?.data?.content) {
      const produtoFgts: ProdutosSimulacao = {
        id: 'fgts',
        perfil: 1,
        qtdeParcelas: Number(response?.data?.content?.quantidadeParcelas),
        servico: 9,
        valorTotalFinanciado: Number(response?.data?.content?.valorLiberado),
        parcelasFgtsItem: response?.data?.content?.parcelasFgtsItem,
        banco: 'BMG',
        codigoFator: '',
        codigoFormaEnvioTermo: null,
        codigoProduto: null,
        cpf: cpfFormatted,
        listProdutos: [],
        listParcelas: [],
        mensagemOperadora: null,
        matricula: '0',
        porcentagemFator: 0,
        valorDesejado: 0,
        valorLimite: 0,
        valorParcela: 0,
        valorSaqueMaximo: 0,
        valorSaqueMinimo: 0,
        valorSaque: maskMoney(0),
        flagSaqueAutorizado: false,
        flagSaqueParcelado: false,
        flagAberturaConta: false,
        bancoSimulacaoEnum: 0,
        margemDisponivel: 0,
        margemDisponivelCartao: 0,
        margemDisponivelCartaoBeneficio: 0,
        tipoProduto: 0,
        produtosSINDNAP: undefined,
        numeroContaInterna: null
      }
      const indexDisponiveis = produtosDisponiveis.findIndex(
        (produto) => produto.servico === produtoFgts.servico
      )
      const indexSelecionados = produtosSelecionados.findIndex(
        (produto) => produto.servico === produtoFgts.servico
      )
      if (indexDisponiveis !== -1) {
        produtosDisponiveis[indexDisponiveis] = produtoFgts
      }
      if (indexSelecionados !== -1) {
        produtosSelecionados[indexSelecionados] = produtoFgts
      }
    }

    yield put(simulacaoActions.setProdutosDisponiveis(produtosDisponiveis))
    yield put(simulacaoActions.setProdutosSelecionados(produtosSelecionados))
    toast.success('Recálculo realizado com sucesso!')
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    if (Array.isArray(error?.messages)) {
      const { messages } = error
      for (const err of messages as Indicacao[]) {
        yield put(
          simulacaoActions.setInfosModalIndicacao({
            indicacao: err.indicacao,
            isOpen: true,
            metodoFgts: MetodosFgts.Recalculo
          })
        )
      }
    } else {
      handlerErrorSimulacaoFgts(
        error,
        'Houve um erro ao realizar o recálculo do FGTS, tente novamente mais tarde.'
      )
    }
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

interface RecalculoCrefazProps extends GenericProps {
  produtoIndex: number
  convenioIndex: number
}

function* recalculoCrefaz({
  produtoIndex,
  convenioIndex
}: RecalculoCrefazProps): SagaIterator {
  const {
    cpf,
    produtosDisponiveis: produtosDisponiveisState,
    produtosSelecionados: produtosSelecionadosState
  }: SIMULACAO = yield select((state: ApplicationState) => state.simulacao)
  try {
    yield put(loadingActions.setLoading(true))
    const produtoCrefaz = produtosDisponiveisState.find(
      (produto) => produto.servico === 13
    )
    const response = yield call(
      simulacaoController.recalculoCrefaz,
      cpf,
      produtoCrefaz?.simulacoesCrefaz?.[produtoIndex].empresasConveniadas[
        convenioIndex
      ].propostaId ?? 0,
      produtoCrefaz?.simulacoesCrefaz?.[produtoIndex].selecionados
        .valorSolicitado ?? 0,
      produtoCrefaz?.simulacoesCrefaz?.[produtoIndex].selecionados
        .convenioDados ?? []
    )
    const produtosDisponiveis = [...produtosDisponiveisState]
    const produtosSelecionados = [...produtosSelecionadosState]
    const indexDisponiveis = produtosDisponiveis.findIndex(
      (produto) => produto.servico === 13
    )
    const indexSelecionados = produtosSelecionados.findIndex(
      (produto) => produto.servico === 13
    )
    if (indexDisponiveis !== -1) {
      produtosDisponiveis[indexDisponiveis] = {
        ...produtosDisponiveis[indexDisponiveis],
        simulacoesCrefaz: produtosDisponiveis[
          indexDisponiveis
        ]?.simulacoesCrefaz?.map((simulacao, index) => {
          if (index === produtoIndex) {
            const listaValoresLiberados: ListaValoresLiberado[] =
              response?.data?.content?.valoresLiberados
            const maiorValorLiberado = listaValoresLiberados?.reduce(
              (max, item) => {
                return item.valor > max.valor ? item : max
              },
              listaValoresLiberados?.[0]
            )

            const maiorPrazo = maiorValorLiberado.listaParcelas?.reduce(
              (max, item) => {
                return item.prazo > max.prazo ? item : max
              },
              maiorValorLiberado.listaParcelas[0]
            )
            return {
              ...simulacao,
              selecionados: {
                ...simulacao.selecionados,
                prazo: maiorPrazo?.prazo ?? null,
                valorParcela: maiorPrazo?.valor ?? null,
                valorSolicitado: maiorValorLiberado?.valor ?? 0
              },
              empresasConveniadas: simulacao.empresasConveniadas.map(
                (empresaConveniada, i) => {
                  if (convenioIndex === i) {
                    return {
                      ...empresaConveniada,
                      listaValoresLiberados:
                        response?.data?.content?.valoresLiberados
                    }
                  }
                  return empresaConveniada
                }
              )
            }
          }
          return simulacao
        })
      }
    }
    if (indexSelecionados !== -1) {
      produtosSelecionados[indexSelecionados] = {
        ...produtosSelecionados[indexSelecionados],
        simulacoesCrefaz: produtosSelecionados[
          indexSelecionados
        ]?.simulacoesCrefaz?.map((simulacao, index) => {
          if (index === produtoIndex) {
            const listaValoresLiberados: ListaValoresLiberado[] =
              response?.data?.content?.valoresLiberados
            const maiorValorLiberado = listaValoresLiberados?.reduce(
              (max, item) => {
                return item.valor > max.valor ? item : max
              },
              listaValoresLiberados?.[0]
            )

            const maiorPrazo = maiorValorLiberado.listaParcelas?.reduce(
              (max, item) => {
                return item.prazo > max.prazo ? item : max
              },
              maiorValorLiberado.listaParcelas[0]
            )
            return {
              ...simulacao,
              selecionados: {
                ...simulacao.selecionados,
                prazo: maiorPrazo?.prazo ?? null,
                valorParcela: maiorPrazo?.valor ?? null,
                valorSolicitado: maiorValorLiberado?.valor ?? 0
              },
              empresasConveniadas: simulacao.empresasConveniadas.map(
                (empresaConveniada, i) => {
                  if (convenioIndex === i) {
                    return {
                      ...empresaConveniada,
                      listaValoresLiberados:
                        response?.data?.content?.valoresLiberados
                    }
                  }
                  return empresaConveniada
                }
              )
            }
          }
          return simulacao
        })
      }
    }
    yield put(simulacaoActions.setProdutosDisponiveis(produtosDisponiveis))
    yield put(simulacaoActions.setProdutosSelecionados(produtosSelecionados))
  } catch (error) {
    handlerError(error, 'Não foi possível recalcular!')
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* validacaoContratacao(): SagaIterator {
  const { cpf, produtosSelecionados, detalhamentoIsOpen }: SIMULACAO =
    yield select((state: ApplicationState) => state.simulacao)
  try {
    if (!produtosSelecionados.length) {
      toast.warn('Não há produtos selecionados!')
      return
    }

    const saqueInvalido = produtosSelecionados.some(
      (produto) =>
        (produto.servico === 5 ||
          produto.servico === 6 ||
          produto.servico === 7 ||
          produto.servico === 8 ||
          produto.servico === 12) &&
        (Number(removeMaskMoney(produto.valorSaque)) >
          produto.valorSaqueMaximo ||
          Number(removeMaskMoney(produto.valorSaque)) <
            produto.valorSaqueMinimo)
    )
    if (saqueInvalido) {
      toast.warn('Insira os valores corretamente para finalizar a contratação')
      return
    }

    const isCrefazInvalido = (produto: ProdutosSimulacao) =>
      produto.servico === 13 &&
      produto.simulacoesCrefaz?.some(
        (p) =>
          p.selecionados.convenioDados.some((c) => c.valor === null) ||
          p.selecionados.valorParcela === null ||
          p.selecionados.prazo === null
      )

    if (produtosSelecionados.some(isCrefazInvalido)) {
      const crefazInvalidoIndex =
        produtosSelecionados.findIndex(isCrefazInvalido)
      const convenioDadosCrefazInvalidoIndex = produtosSelecionados[
        crefazInvalidoIndex
      ]?.simulacoesCrefaz?.findIndex(
        (simulacao) =>
          simulacao.selecionados.convenioDados.some((c) => c.valor === null) ||
          simulacao.selecionados.valorParcela === null ||
          simulacao.selecionados.prazo === null
      )

      const produtoSelecionado = produtosSelecionados[crefazInvalidoIndex]

      if (!detalhamentoIsOpen) {
        yield put(simulacaoActions.toggleDetalhamento())
      }

      yield put(
        simulacaoActions.selectProduto({
          servico: produtoSelecionado.servico,
          matricula: produtoSelecionado.matricula ?? '',
          produtoCrefazId:
            produtoSelecionado.simulacoesCrefaz?.[
              convenioDadosCrefazInvalidoIndex ?? 0
            ].produtoId
        })
      )

      const simulacoesCrefaz = produtoSelecionado.simulacoesCrefaz
      const camposInvalidos =
        simulacoesCrefaz?.flatMap((simulacao) =>
          simulacao.selecionados.convenioDados
            .filter((c) => c.valor === null)
            .map((c) => c.descricao)
        ) || []

      return yield put(
        simulacaoActions.setValidacaoErroCrefaz({
          mensagem:
            'Insira os dados corretamente para finalizar a contratação do Crefaz:',
          camposInvalidos: camposInvalidos
        })
      )
    }

    yield put(loadingActions.setLoading(true))
    const cpfFormatted = removeMaskCPF(cpf)
    const matriculasContratacao = produtosSelecionados
      .map((produto) => produto.matricula)
      .filter((v) => v != null)

    const bancos = produtosSelecionados
      .map((produto) => produto.bancoSimulacaoEnum)
      .filter((v) => v != null)
    const response = yield call(
      simulacaoController.validacaoContratacao,
      cpfFormatted,
      [...new Set(matriculasContratacao)],
      [...new Set(bancos)]
    )
    if (!response?.data?.content.temArquivoCrefaz) {
      return yield put(simulacaoActions.toggleModalUploadCrefaz(true))
    }
    if (response?.data?.content.url) {
      stepCadastroComplementarRedirect(
        response?.data?.content.dadosComplementaresEnum
      )
    } else {
      yield put(
        simulacaoActions.toggleModalResumoContratacao(response?.data?.success)
      )
    }
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* getResumoContratacao(): SagaIterator {
  const { cpf, produtosSelecionados }: SIMULACAO = yield select(
    (state: ApplicationState) => state.simulacao
  )
  try {
    yield put(loadingActions.setLoading(true))
    const cpfFormatted = removeMaskCPF(cpf)
    const matriculasContratacao = produtosSelecionados
      .map((produto) => produto.matricula)
      .filter((v) => v != null)

    const bancos = produtosSelecionados
      .map((produto) => produto.bancoSimulacaoEnum)
      .filter((v) => v != null)
    const response = yield call(
      simulacaoController.getResumoContratacao,
      cpfFormatted,
      [...new Set(matriculasContratacao)],
      [...new Set(bancos)]
    )

    const infosClienteResumo: InfosClienteResumo = {
      bairro: response?.data?.content?.bairro,
      cep: response?.data?.content?.cep,
      cidade: response?.data?.content?.cidade,
      cidadeNascimento: response?.data?.content?.cidadeNascimento,
      complemento: response?.data?.content?.complemento,
      cpf: maskCPF(response?.data?.content?.cpf),
      dataEmissao: moment(response?.data?.content?.dataEmissao).format(
        'DD/MM/YYYY'
      ),
      dataNascimento: moment(response?.data?.content?.dataNascimento).format(
        'DD/MM/YYYY'
      ),
      emissorIdentidade: response?.data?.content?.emissorIdentidade,
      estadoCivil: response?.data?.content?.estadoCivil,
      grauInstrucao: response?.data?.content?.grauInstrucao,
      matriculas: response?.data?.content?.matriculas.map(
        (matricula: MatriculaResumo) => {
          return {
            id: matricula.id,
            numeroMatricula: matricula.numeroMatricula,
            tipoPerfil: matricula.tipoPerfil,
            descricaoPerfil: matricula.descricaoPerfil,
            tipoPerfilId: matricula.tipoPerfilId,
            convenioId: matricula.convenioId,
            margemDisponivel: matricula.margemDisponivel,
            margemCartaoDisponivel: matricula.margemCartaoDisponivel,
            margemCartaoBeneficio: matricula.margemCartaoBeneficio,
            descricaoBanco: matricula.descricaoBanco,
            contaCorrenteId: matricula.contaCorrenteId,
            tipoContaId: matricula.tipoContaId,
            bancoDadosBancariosId: matricula.bancoDadosBancariosId,
            numeroAgencia: matricula.numeroAgencia,
            digitoVerificadorAgencia: matricula.digitoVerificadorAgencia,
            numeroConta: matricula.numeroConta,
            digitoVerificadorConta: matricula.digitoVerificadorConta
          }
        }
      ),
      nacionalidade: response?.data?.content?.nacionalidade,
      nome: response?.data?.content?.nome,
      nomeConjuge: response?.data?.content?.nomeConjuge,
      nomeMae: response?.data?.content?.nomeMae,
      nomePai: response?.data?.content?.nomePai,
      numeroEndereco: response?.data?.content?.numeroEndereco,
      numeroIdentidade: response?.data?.content?.numeroIdentidade,
      sexo: response?.data?.content?.sexo,
      uf: response?.data?.content?.uf,
      ufIdentidade: response?.data?.content?.ufIdentidade,
      ufNascimento: response?.data?.content?.ufNascimento,
      logradouro: response?.data?.content?.logradouro,
      numero: response?.data?.content?.numero,
      ddd: response?.data?.content?.ddd,
      contaCorrentePrincipal: response?.data?.content?.contaCorrentePrincipal
    }

    yield put(simulacaoActions.setInfosClienteResumo(infosClienteResumo))
    yield call(cadastroInicialController.atualizarContatoRDStation, null, {
      tags: ['etapa_resumodacontratacao']
    })
  } catch (error) {
    handlerError(error, 'Não foi possível carregar as informações do cliente!')
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

interface FinalizaContratacoesProps {
  produto: ProdutosSimulacao
  infosCrefaz?: FinalizacaoEmprestimoCrefaz
}

function* finalizacaoContratacao(): SagaIterator {
  const { cpf, produtosSelecionados: produtosSelecionadosState }: SIMULACAO =
    yield select((state: ApplicationState) => state.simulacao)
  yield put(loadingActions.setLoading(true))
  const cpfFormatted = removeMaskCPF(cpf)
  const contratacoesComSucesso: any[] = []
  function* finalizaContratacoes({
    produto,
    infosCrefaz
  }: FinalizaContratacoesProps): Generator<
    CallEffect,
    void,
    AxiosResponse<ResponseWithMessages<ProdutosSimulacao[] | ReqFgts<null>>>
  > {
    try {
      switch (produto.servico) {
        case 1: {
          let response
          if (produto.bancoSimulacaoEnum === 1) {
            response = yield call(
              simulacaoController.finalizacaoEmprestimoBmg,
              {
                cpf: cpfFormatted,
                numeroMatricula: produto.matricula,
                quantidadeParcelas: produto.qtdeParcelas,
                valorParcela: produto.valorParcela,
                servico: produto.servico,
                numeroProduto: produto.codigoProduto || 0,
                bancoSimulacaoEnum: produto.bancoSimulacaoEnum,
                codigoFormaEnvioTermo: produto.codigoFormaEnvioTermo ?? '',
                valorLiberado: produto.valorTotalFinanciado
              }
            )
          }
          if (produto.bancoSimulacaoEnum === 2) {
            response = yield call(
              simulacaoController.finalizacaoEmprestimoItau,
              {
                codigoSimulacao: produto.codigoSimulacao || 0,
                cpf: cpfFormatted,
                numeroMatricula: produto.matricula,
                quantidadeParcelas: produto.qtdeParcelas,
                valorParcela: produto.valorParcela,
                servico: produto.servico,
                bancoSimulacaoEnum: produto.bancoSimulacaoEnum,
                valorLiberado: produto.valorTotalFinanciado
              }
            )
          }
          if (
            response?.data?.content?.message ||
            response?.data?.content?.messages?.length > 0
          ) {
            if (response?.data?.content?.messages?.length > 0) {
              response?.data?.content?.messages?.map((message: string) => {
                toast.success(message)
              })
            } else {
              toast.success(response?.data?.content?.message)
            }
          } else {
            toast.success('Contratação finalizada com sucesso!')
          }
          break
        }
        case 5: {
          const response = yield call(
            simulacaoController.finalizacaoSaqueCartaoBmg,
            {
              cpf: cpfFormatted,
              numeroMatricula: produto.matricula,
              numeroContaInterna: produto.numeroContaInterna || 0,
              quantidadeParcelas: produto.qtdeParcelas,
              valorParcela: produto.valorParcela,
              valorSaque: produto.flagSaqueAutorizado
                ? Number(removeMaskMoney(produto.valorSaque))
                : produto.valorLimite,
              flagSaqueAutorizado: produto.flagSaqueAutorizado,
              flagAberturaConta: produto.flagAberturaConta,
              servico: produto.servico,
              bancoSimulacaoEnum: produto.bancoSimulacaoEnum
            }
          )
          if (
            response?.data?.content?.message ||
            response?.data?.content?.messages?.length > 0
          ) {
            if (response?.data?.content?.messages?.length > 0) {
              response?.data?.content?.messages?.map((message: string) => {
                toast.success(message)
              })
            } else {
              toast.success(response?.data?.content?.message)
            }
          } else {
            toast.success('Contratação finalizada com sucesso!')
          }
          break
        }
        case 6: {
          const response = yield call(
            simulacaoController.finalizacaoCartaoCreditoBmg,
            {
              cpf: cpfFormatted,
              numeroMatricula: produto.matricula,
              valorSaque: produto.flagSaqueAutorizado
                ? Number(removeMaskMoney(produto.valorSaque))
                : produto.valorLimite,
              servico: produto.servico,
              flagAberturaConta: produto.flagAberturaConta,
              flagSaqueAutorizado: produto.flagSaqueAutorizado,
              bancoSimulacaoEnum: produto.bancoSimulacaoEnum
            }
          )
          if (
            response?.data?.content?.message ||
            response?.data?.content?.messages?.length > 0
          ) {
            if (response?.data?.content?.messages?.length > 0) {
              response?.data?.content?.messages?.map((message: string) => {
                toast.success(message)
              })
            } else {
              toast.success(response?.data?.content?.message)
            }
          } else {
            toast.success('Contratação finalizada com sucesso!')
          }
          break
        }
        case 7: {
          const response = yield call(
            simulacaoController.finalizacaoCartaoBeneficioBmg,
            {
              cpf: cpfFormatted,
              numeroMatricula: produto.matricula,
              flagSaqueAutorizado: produto.flagSaqueAutorizado,
              flagSaqueParcelado: produto.flagSaqueParcelado,
              quantidadeParcelas: produto.qtdeParcelas,
              valorParcela: produto.valorParcela,
              valorSaque:
                produto.flagSaqueAutorizado || produto.flagSaqueParcelado
                  ? Number(removeMaskMoney(produto.valorSaque))
                  : produto.valorLimite,
              servico: produto.servico,
              flagAberturaConta: produto.flagAberturaConta,
              bancoSimulacaoEnum: produto.bancoSimulacaoEnum
            }
          )
          if (
            response?.data?.content?.message ||
            response?.data?.content?.messages?.length > 0
          ) {
            if (response?.data?.content?.messages?.length > 0) {
              response?.data?.content?.messages?.map((message: string) => {
                toast.success(message)
              })
            } else {
              toast.success(response?.data?.content?.message)
            }
          } else {
            toast.success('Contratação finalizada com sucesso!')
          }
          break
        }
        case 8: {
          const response = yield call(
            simulacaoController.finalizacaoSaqueCartaoBmg,
            {
              cpf: cpfFormatted,
              numeroMatricula: produto.matricula,
              numeroContaInterna: produto.numeroContaInterna || 0,
              quantidadeParcelas: produto.qtdeParcelas,
              valorParcela: produto.valorParcela,
              valorSaque: produto.flagSaqueAutorizado
                ? Number(removeMaskMoney(produto.valorSaque))
                : produto.valorLimite,
              flagSaqueAutorizado: produto.flagSaqueAutorizado,
              flagAberturaConta: produto.flagAberturaConta,
              servico: produto.servico,
              bancoSimulacaoEnum: produto.bancoSimulacaoEnum
            }
          )
          if (
            response?.data?.content?.message ||
            response?.data?.content?.messages?.length > 0
          ) {
            if (response?.data?.content?.messages?.length > 0) {
              response?.data?.content?.messages?.map((message: string) => {
                toast.success(message)
              })
            } else {
              toast.success(response?.data?.content?.message)
            }
          } else {
            toast.success('Contratação finalizada com sucesso!')
          }
          break
        }
        case 9: {
          yield call(simulacaoController.finalizacaoContratacaoFgts)
          toast.success('Contratação FGTS finalizada com sucesso!')
          break
        }
        case 12: {
          const response = yield call(
            simulacaoController.finalizacaoContratacaoSeguroSindinapiBmg,
            {
              cpf: cpfFormatted,
              numeroMatricula: produto.matricula,
              servico: produto.servico,
              bancoSimulacaoEnum: produto.bancoSimulacaoEnum
            }
          )
          if (
            response?.data?.content?.message ||
            response?.data?.content?.messages?.length > 0
          ) {
            if (response?.data?.content?.messages?.length > 0) {
              response?.data?.content?.messages?.map((message: string) => {
                toast.success(message)
              })
            } else {
              toast.success(response?.data?.content?.message)
            }
          } else {
            toast.success('Contratação finalizada com sucesso!')
          }
          break
        }
        case 13: {
          const response = yield call(
            simulacaoController.finalizacaoContratacaoEmprestimoCrefaz,
            {
              cpf: infosCrefaz?.cpf ?? '',
              servico: infosCrefaz?.servico ?? 13,
              propostaId: infosCrefaz?.propostaId ?? 0,
              tabelaJurosId: infosCrefaz?.tabelaJurosId ?? 0,
              valorSolicitado: infosCrefaz?.valorSolicitado ?? 0,
              valorParcela: infosCrefaz?.valorParcela ?? 0,
              quantidadeParcelas: infosCrefaz?.quantidadeParcelas ?? 0,
              vencimento: infosCrefaz?.vencimento ?? '',
              produtoId: infosCrefaz?.produtoId ?? 0,
              convenioId: infosCrefaz?.convenioId ?? 0,
              rendaPresumida: infosCrefaz?.rendaPresumida ?? 0
            }
          )
          if (
            response?.data?.content?.message ||
            response?.data?.content?.messages?.length > 0
          ) {
            if (response?.data?.content?.messages?.length > 0) {
              response?.data?.content?.messages?.map((message: string) => {
                toast.success(message)
              })
            } else {
              toast.success(response?.data?.content?.message)
            }
          } else {
            toast.success('Contratação finalizada com sucesso!')
          }
          break
        }
        default:
          break
      }
      contratacoesComSucesso.push(produto)
    } catch (error) {
      if (produto.servico !== 9) {
        handlerError(error, 'Não foi possível realizar a contratação!')
      } else {
        handlerErrorFgts(
          error,
          'Não foi possível realizar a contratação do FGTS!'
        )
      }
    }
  }
  yield all(
    produtosSelecionadosState?.flatMap((produto) => {
      if (produto.servico === 13) {
        return (
          produto.simulacoesCrefaz?.map((simulacao) => {
            const convenioIndex = simulacao.empresasConveniadas.findIndex(
              (empresa) =>
                empresa.convenioId === simulacao.selecionados.convenioId
            )
            return call(finalizaContratacoes, {
              produto,
              infosCrefaz: {
                cpf: produto.cpf,
                servico: produto.servico,
                propostaId:
                  simulacao.empresasConveniadas[convenioIndex ?? 0].propostaId,
                tabelaJurosId:
                  simulacao.empresasConveniadas[convenioIndex ?? 0]
                    .tabelaJurosId,
                valorSolicitado: simulacao.selecionados.valorSolicitado,
                valorParcela: simulacao.selecionados.valorParcela ?? 0,
                quantidadeParcelas: simulacao.selecionados.prazo ?? 0,
                vencimento:
                  simulacao.empresasConveniadas[convenioIndex ?? 0].vencimento,
                produtoId: simulacao.produtoId,
                convenioId: simulacao.selecionados.convenioId,
                rendaPresumida: simulacao.rendaPresumida
              }
            })
          }) || []
        )
      }
      return [call(finalizaContratacoes, { produto })]
    })
  )
  if (contratacoesComSucesso.length > 0) {
    const valorTotalNumerico = {
      cf_site_valor_disponivel_cartao_beneficio: 0,
      cf_site_valor_disponivel_cartao_consignado: 0,
      cf_site_valor_disponivel_saque_aniversario_fgts: 0,
      cf_site_valor_disponivel_saque_cartao_beneficio: 0,
      cf_site_valor_disponivel_saque_cartao_consignado: 0,
      cf_site_valor_disponivel_crefaz: 0,
      cf_site_valor_disponivel_portabilidade: 0,
      cf_site_valor_disponivel_refin: 0,
      cf_site_valor_disponivel_emprestimo_consignado: 0
    }

    const tags = new Set<string>()

    contratacoesComSucesso.forEach((produto) => {
      const { valorTotalFinanciado, valorSaque, valorPremioAux } = (() => {
        const valorTotalFinanciado = Number(produto.valorTotalFinanciado ?? 0)
        const valorSaque = produto.valorSaque
          ? Number(removeMaskMoney(produto.valorSaque))
          : 0
        const valorPremioAux = Number(
          produto.produtosSINDNAP?.planos?.[0]?.valorPremioAux ?? 0
        )
        return { valorTotalFinanciado, valorSaque, valorPremioAux }
      })()

      switch (produto.servico) {
        case 6:
          valorTotalNumerico.cf_site_valor_disponivel_cartao_consignado +=
            valorSaque
          tags.add('contratadocomsucesso_cartao_consignado')
          break
        case 7:
          valorTotalNumerico.cf_site_valor_disponivel_cartao_beneficio +=
            valorSaque
          tags.add('contratadocomsucesso_cartao_beneficio')
          break
        case 8:
          valorTotalNumerico.cf_site_valor_disponivel_saque_cartao_beneficio +=
            valorSaque
          tags.add('contratadocomsucesso_saque_cartao_beneficio')
          break
        case 5:
          valorTotalNumerico.cf_site_valor_disponivel_saque_cartao_consignado +=
            valorSaque
          tags.add('contratadocomsucesso_saque_cartao_consignado')
          break
        case 9:
          valorTotalNumerico.cf_site_valor_disponivel_saque_aniversario_fgts +=
            valorTotalFinanciado
          tags.add('contratadocomsucesso_fgts')
          break
        case 13:
          valorTotalNumerico.cf_site_valor_disponivel_crefaz += valorPremioAux
          tags.add('contratadocomsucesso_crefaz')
          break
        case 2:
          valorTotalNumerico.cf_site_valor_disponivel_refin +=
            valorTotalFinanciado
          tags.add('contratadocomsucesso_refin')
          break
        case 1:
          valorTotalNumerico.cf_site_valor_disponivel_emprestimo_consignado +=
            valorTotalFinanciado
          tags.add('contratadocomsucesso_emprestimo_consignado')
          break
      }
    })

    const valorTotalPorProduto = Object.fromEntries(
      Object.entries(valorTotalNumerico).map(([chave, valor]) => [
        chave,
        valor > 0 ? valor.toFixed(2) : ''
      ])
    )

    const somatorioTotalProdutos = contratacoesComSucesso
      .map((produto) => {
        if (
          produto.servico === 5 ||
          produto.servico === 6 ||
          produto.servico === 7 ||
          produto.servico === 8
        ) {
          if (!produto.flagSaqueAutorizado && !produto.flagSaqueParcelado) {
            return 0
          } else {
            return Number(removeMaskMoney(produto.valorSaque))
          }
        } else if (produto.servico === 13) {
          let valor = 0
          for (const simulacao of produto.simulacoesCrefaz ?? []) {
            valor += simulacao.selecionados.valorSolicitado
          }
          return valor
        } else {
          return produto.valorTotalFinanciado
        }
      })
      .reduce((prev, curr) => prev + curr, 0)

    yield call(cadastroInicialController.atualizarContatoRDStation, null, {
      cf_site_valor_contratado_total: String(somatorioTotalProdutos.toFixed(2)),
      tags: ['etapa_contratadocomsucesso', ...Array.from(tags)],
      ...valorTotalPorProduto
    })
  }
  yield put(simulacaoActions.toggleModalResumoContratacao(false))
  // yield put(simulacaoActions.getPropostasSaga())
  yield put(loadingActions.setLoading(false))
  history.push('/propostas')
}

function* getPerfisResumo(): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))
    const response = yield call(simulacaoController.getPerfis)
    yield put(
      simulacaoActions.setOptionsSelect(response?.data?.content, 'perfis')
    )
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* getTiposContaResumo(): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))
    const response = yield call(simulacaoController.getTiposConta)
    yield put(
      simulacaoActions.setOptionsSelect(response?.data?.content, 'tiposConta')
    )
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* getBancosResumo(): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))
    const response = yield call(simulacaoController.getBancos)
    yield put(
      simulacaoActions.setOptionsSelect(response?.data?.content, 'bancos')
    )
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* getConveniosResumo(): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))
    const response = yield call(simulacaoController.getConvenios)
    yield put(
      simulacaoActions.setOptionsSelect(response?.data?.content, 'convenios')
    )
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* inserirSolicitacoesIn100(): SagaIterator {
  const { validacaoFields }: SIMULACAO = yield select(
    (state: ApplicationState) => state.simulacao
  )
  try {
    yield put(loadingActions.setLoading(true))
    yield call(simulacaoController.inserirSolicitacaoIn100, {
      ddd: validacaoFields.celular.substring(1, 3),
      telefone: validacaoFields.celular.substring(5).replace('-', ''),
      matricula: validacaoFields.matricula
    })
    toast.success('Enviado código para o seu celular')
  } catch (error) {
    handlerError(error, 'Não foi possível enviar a solicitação')
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

// function* validarTokenIn100(): SagaIterator {
//   const { validacaoFields }: SIMULACAO = yield select(
//     (state: ApplicationState) => state.simulacao
//   )
//   try {
//     yield put(loadingActions.setLoading(true))
//     yield call(simulacaoController.validarTokenIn100, {
//       token: validacaoFields.codigo,
//       matricula: validacaoFields.matricula
//     })
//     yield put(simulacaoActions.toggleModalIN100(false))
//     toast.success('Código validado com sucesso')
//     yield put(simulacaoActions.validaStatusIN100Saga())
//   } catch (error) {
//     handlerError(error, 'Não foi possível validar o código')
//   } finally {
//     yield put(loadingActions.setLoading(false))
//   }
// }

function* getTiposDocumentoCrefaz(): SagaIterator {
  try {
    yield put(simulacaoActions.setLoadingSelect(true, 'tiposDocumentoCrefaz'))
    const response = yield call(simulacaoController.getTiposDocumentoCrefaz)
    yield put(
      simulacaoActions.setOptionsSelect(
        response?.data?.content,
        'tiposDocumentoCrefaz'
      )
    )
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(simulacaoActions.setLoadingSelect(false, 'tiposDocumentoCrefaz'))
  }
}

function* uploadArquivosCrefaz(): SagaIterator {
  const { arquivosCrefaz, cpf }: SIMULACAO = yield select(
    (state: ApplicationState) => state.simulacao
  )
  try {
    yield put(loadingActions.setLoading(true))
    yield all(
      arquivosCrefaz.map((arquivo) =>
        call(function* () {
          try {
            yield call(simulacaoController.uploadArquivosCrefaz, {
              cpf,
              tipoArquivoCrefazId: arquivo.tipoArquivo,
              arquivo
            })
            toast.success(
              `Arquivo ${arquivo.uploadedFile?.name || ''} enviado com sucesso`
            )
          } catch (error) {
            toast.error(
              `Erro ao enviar o arquivo ${arquivo.uploadedFile?.name || ''}`
            )
          }
        })
      )
    )
    yield put(simulacaoActions.toggleModalUploadCrefaz(false))
    yield put(simulacaoActions.validacaoContratacaoSaga())
  } catch (error) {
    handlerError(error, 'Não foi possível enviar os arquivos')
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* getGrausReferencia(): SagaIterator {
  try {
    yield put(simulacaoActions.setLoadingSelect(true, 'grausReferencia'))
    const response = yield call(simulacaoController.getGrausReferencia)
    yield put(
      simulacaoActions.setOptionsSelect(
        response?.data?.content,
        'grausReferencia'
      )
    )
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(simulacaoActions.setLoadingSelect(false, 'grausReferencia'))
  }
}

function* getReferencias(): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))
    yield put(simulacaoActions.cleanReferencias())
    const response = yield call(simulacaoController.getReferencias)
    const garantirMinimoDuasReferencias = (referencias: Referencia[]) => {
      const referenciaVazia = {
        nome: '',
        ddd: '',
        numero: '',
        grauReferenciaCrefazId: ''
      }
      if (!referencias || referencias.length === 0) {
        return [referenciaVazia, referenciaVazia]
      }
      if (referencias.length === 1) {
        return [...referencias, referenciaVazia]
      }
      return referencias
    }
    const referenciasAjustadas = garantirMinimoDuasReferencias(
      response?.data?.content
    )
    yield put(simulacaoActions.setReferencias(referenciasAjustadas))
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* salvarReferencias(): SagaIterator {
  const { referencias }: SIMULACAO = yield select(
    (state: ApplicationState) => state.simulacao
  )
  try {
    yield put(loadingActions.setLoading(true))
    yield call(simulacaoController.salvarReferencias, referencias)
    yield put(simulacaoActions.cleanReferencias())
    yield put(simulacaoActions.getReferenciasSaga())
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* watchGetClienteMatriculaCpf() {
  yield takeEvery(TYPES.GET_CLIENTE_MATRICULA_CPF_SAGA, getClienteMatriculaCpf)
}

function* watchValidaStatusIN100() {
  yield takeEvery(TYPES.VALIDA_STATUS_IN100_SAGA, validaStatusIN100)
}

function* watchGetPropostas() {
  yield takeEvery(TYPES.GET_PROPOSTAS_SAGA, getPropostas)
}

function* watchSolicitarSimulacaoFgts() {
  yield takeEvery(TYPES.SOLICITAR_SIMULACAO_FGTS_SAGA, solicitarSimulacaoFgts)
}

function* watchGetParcelasFgts() {
  yield takeEvery(TYPES.GET_PARCELAS_FGTS_SAGA, getParcelasFgts)
}

function* watchRecalculoProposta() {
  yield takeEvery(TYPES.RECALCULO_PROPOSTA_SAGA, recalculoProposta)
}

function* watchRecalculoPropostaFgts() {
  yield takeEvery(TYPES.RECALCULO_PROPOSTA_FGTS_SAGA, recalculoPropostaFgts)
}

function* watchRecalculoCrefaz() {
  yield takeEvery(TYPES.RECALCULO_CREFAZ_SAGA, recalculoCrefaz)
}

function* watchValidacaoContratacao() {
  yield takeEvery(TYPES.VALIDACAO_CONTRATACAO_SAGA, validacaoContratacao)
}

function* watchGetResumoContratacao() {
  yield takeEvery(TYPES.GET_RESUMO_CONTRATACAO_SAGA, getResumoContratacao)
}

function* watchFinalizacaoContratacao() {
  yield takeEvery(TYPES.FINALIZACAO_CONTRATACAO_SAGA, finalizacaoContratacao)
}

function* watchGetPerfisResumo() {
  yield takeEvery(TYPES.GET_PERFIS_RESUMO_SAGA, getPerfisResumo)
}

function* watchGetTiposContaResumo() {
  yield takeEvery(TYPES.GET_TIPOS_CONTA_RESUMO_SAGA, getTiposContaResumo)
}

function* watchGetBancosResumo() {
  yield takeEvery(TYPES.GET_BANCOS_RESUMO_SAGA, getBancosResumo)
}

function* watchGetConveniosResumo() {
  yield takeEvery(TYPES.GET_CONVENIOS_RESUMO_SAGA, getConveniosResumo)
}

function* watchInserirSolicitacoesIn100() {
  yield takeEvery(
    TYPES.INSERIR_SOLICITACOES_IN100_SAGA,
    inserirSolicitacoesIn100
  )
}

// function* watchValidarTokenIn100() {
//   yield takeEvery(TYPES.VALIDAR_TOKEN_IN100_SAGA, validarTokenIn100)
// }

function* watchGetTiposDocumentoCrefaz() {
  yield takeEvery(
    TYPES.GET_TIPOS_DOCUMENTO_CREFAZ_SAGA,
    getTiposDocumentoCrefaz
  )
}

function* watchUploadArquivosCrefaz() {
  yield takeEvery(TYPES.UPLOAD_ARQUIVOS_CREFAZ_SAGA, uploadArquivosCrefaz)
}

function* watchGrausReferencia() {
  yield takeEvery(TYPES.GET_GRAUS_REFERENCIA_SAGA, getGrausReferencia)
}

function* watchGetReferencias() {
  yield takeEvery(TYPES.GET_REFERENCIAS_SAGA, getReferencias)
}

function* watchSalvarReferencias() {
  yield takeEvery(TYPES.SALVAR_REFERENCIAS_SAGA, salvarReferencias)
}

function* simulacao() {
  yield all([
    fork(watchGetClienteMatriculaCpf),
    fork(watchValidaStatusIN100),
    fork(watchGetPropostas),
    fork(watchSolicitarSimulacaoFgts),
    fork(watchGetParcelasFgts),
    fork(watchRecalculoProposta),
    fork(watchRecalculoPropostaFgts),
    fork(watchRecalculoCrefaz),
    fork(watchValidacaoContratacao),
    fork(watchGetResumoContratacao),
    fork(watchFinalizacaoContratacao),
    fork(watchGetPerfisResumo),
    fork(watchGetTiposContaResumo),
    fork(watchGetBancosResumo),
    fork(watchGetConveniosResumo),
    fork(watchInserirSolicitacoesIn100),
    // fork(watchValidarTokenIn100),
    fork(watchGetTiposDocumentoCrefaz),
    fork(watchUploadArquivosCrefaz),
    fork(watchGrausReferencia),
    fork(watchGetReferencias),
    fork(watchSalvarReferencias)
  ])
}

export default simulacao
